/* shani-cart-guard: פריט יחיד לא נכנס לסל פעמיים. משותף לדף המוצר, לקטגוריה ולחיפוש.
   רץ בשלב ה-capture, לפני המטפל של התבנית (theme.js), על כל [data-btn-addToCart] שיושב בטופס עם input[name=id].
   מפת הסל (inCart) מתעדכנת בטעינת הדף, בכל cart-update שהתבנית משדרת, ובחזרה לדף (pageshow, visibilitychange).
   המפה ידועה וטרייה והפריט לא בסל: הלחיצה ממשיכה מיד למטפל של התבנית, בלי בקשת רשת בדרך.
   המפה עוד לא נטענה או ישנה (MAX_AGE): הכפתור עובר מיד ל-is-loading, נשאלת /cart.js, ורק אז הלחיצה עוברת.
   הפריט כבר בסל: עוצר. בקטגוריה מוצגת "הפריט כבר בסל שלך.", בדף המוצר נפתח הסל.
   בקטגוריה ובחיפוש (.productListing): כרטיס של פריט שבסל מקבל "בסל" מושבת (מפרט §3.4), וחוזר לרגיל כשהפריט יוצא מהסל. */
(function () {
  if (window.__shaniCartGuard) return;
  window.__shaniCartGuard = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* כמה זמן סומכים על המפה בלי לשאול את השרת. כל שינוי סל בלשונית הזו משדר cart-update, וחזרה ללשונית מסנכרנת.
     הסף מגן רק על שינוי שקט מבחוץ (חלון שני שפתוח במקביל). */
  var MAX_AGE = 300000;
  var busy = {};
  var waiting = {};
  var inCart = {};
  var known = false, syncedAt = 0, syncP = null;
  var toast = document.querySelector('[data-shp-toast]');
  var toastT = null;
  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'shg-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.hidden = true;
    var sp = document.createElement('span'); sp.textContent = 'הפריט כבר בסל שלך.';
    var a = document.createElement('a'); a.href = (window.routes && window.routes.cart) || '/cart'; a.textContent = 'לסל';
    toast.appendChild(sp); toast.appendChild(document.createTextNode(' ')); toast.appendChild(a);
    document.body.appendChild(toast);
    return toast;
  }
  function showToast() {
    var t = ensureToast();
    t.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.hidden = true; }, 4000);
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function markCards() {
    document.querySelectorAll('.productListing [data-btn-addtocart]').forEach(function (b) {
      var f = b.closest('form'); var inp = f && f.querySelector('input[name="id"]');
      if (!inp) return;
      var on = !!inCart[String(inp.value)], has = b.classList.contains('shg-incart');
      if (on && !has) {
        if (!b.hasAttribute('data-shg-card')) b.setAttribute('data-shg-card', b.textContent);
        b.classList.add('shg-incart');
        b.disabled = true;
        b.setAttribute('aria-disabled', 'true');
        b.textContent = 'בסל';
      } else if (!on && has && known) {
        /* הפריט יצא מהסל: הכרטיס חוזר למצב רגיל, בלי רענון */
        b.classList.remove('shg-incart');
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        if (b.hasAttribute('data-shg-card')) { b.textContent = b.getAttribute('data-shg-card'); b.removeAttribute('data-shg-card'); }
      }
    });
  }
  /* דף המוצר: הכפתור הראשי והכפתור שבפס הדביק ([data-shp-guard]) עוברים למצב "בסל" (.shg-view) כשהפריט כבר בסל, וחוזרים לנוסח המקורי כשהוא יוצא ממנו.
     במצב הזה הכפתור נשאר לחיץ ופותח את הסל. הוא לעולם לא שולח הוספה. הסגנון כאן ולא ב-shani-product.css: המצב קיים רק כשהסקריפט רץ. */
  var VIEW_MAIN = 'הפריט בסל · לצפייה', VIEW_BAR = 'לצפייה בסל';
  function viewCss() {
    if (document.getElementById('shg-view-css')) return;
    var st = document.createElement('style');
    st.id = 'shg-view-css';
    st.textContent =
      '.shp .shp-btn.shg-view{box-sizing:border-box;background:#fff;color:#232323;border:1.5px solid #B88C2D;gap:8px}' +
      '.shp .shp-btn.shg-view svg{flex:none;width:20px;height:20px;fill:none;stroke:#232323;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
      '.shp .shp-sbar .shp-btn.shg-view span{white-space:nowrap}' +
      '@media (hover:hover){.shp .shp-btn.shg-view:hover{background:#fff;border-color:#B88C2D;box-shadow:inset 0 0 0 1.5px #B88C2D}}' +
      '.shp .shp-btn.shg-view:active{background:#B88C2D;border-color:#B88C2D}';
    document.head.appendChild(st);
  }
  function viewOn(b) {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg'); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(NS, 'path'); p.setAttribute('d', 'M5 12.5l4.5 4.5L19 7.5'); svg.appendChild(p);
    var sp = document.createElement('span'); sp.textContent = b.closest('[data-shp-sbar]') ? VIEW_BAR : VIEW_MAIN;
    viewCss();
    b.setAttribute('data-shg-label', b.textContent);
    b.textContent = '';
    b.appendChild(svg); b.appendChild(sp);
    b.classList.add('shg-view');
  }
  function viewOff(b) {
    b.textContent = b.getAttribute('data-shg-label');
    b.removeAttribute('data-shg-label');
    b.classList.remove('shg-view');
  }
  function markPdp() {
    document.querySelectorAll('[data-shp-guard]').forEach(function (b) {
      var f = b.closest('form'); var inp = f && f.querySelector('input[name="id"]');
      var on = !!(inp && inCart[String(inp.value)]);
      if (on === b.hasAttribute('data-shg-label')) return;
      if (on) viewOn(b); else viewOff(b);
    });
  }
  /* פתיחת הסל: המגירה, באותה מחלקה שהתבנית שמה על body בלחיצה על אייקון הסל (theme.js, initSidebarCart). אין מגירה בדף: /cart */
  function openCart() {
    if (document.getElementById('halo-cart-sidebar') && !document.body.classList.contains('template-cart')) { document.body.classList.add('cart-sidebar-show'); return; }
    location.href = (window.routes && window.routes.cart) || '/cart';
  }
  /* t0: הרגע שבו הסל הזה היה נכון (שליחת הבקשה, או רגע האירוע). תשובה ישנה ממה שכבר ידוע לא דורסת אותו */
  function applyCart(c, t0) {
    if (!c || !Array.isArray(c.items) || t0 < syncedAt) return;
    inCart = {};
    c.items.forEach(function (it) { inCart[String(it.variant_id)] = true; });
    known = true;
    syncedAt = t0;
    markCards();
    markPdp();
  }
  /* בקשה אחת בכל רגע: מי שמבקשת סנכרון בזמן שאחד כבר בדרך מקבלת את אותה תשובה */
  function syncCart() {
    if (syncP) return syncP;
    var t0 = Date.now();
    syncP = getCart().then(function (c) { applyCart(c, t0); return c; }).catch(function () { return null; }).then(function (c) { syncP = null; return c; });
    return syncP;
  }
  /* הלחיצה עברה למטפל של התבנית: 3 שניות בלי לחיצה נוספת, וסנכרון גיבוי למקרה שהתבנית לא שידרה cart-update */
  function passed(b, vid) {
    busy[vid] = Date.now() + 3000;
    if (b.closest('.productListing')) setTimeout(syncCart, 2500);
    else if (b.hasAttribute('data-shp-guard')) { setTimeout(syncCart, 1200); setTimeout(syncCart, 3500); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-btn-addtocart]');
    if (!b) return;
    var f = b.closest('form');
    var inp = f && f.querySelector('input[name="id"]');
    if (!inp || !inp.value) return;
    var vid = String(inp.value);
    if (b.getAttribute('data-shg-pass') === '1') {
      b.removeAttribute('data-shg-pass');
      passed(b, vid);
      return;
    }
    var now = Date.now();
    var pdp = b.hasAttribute('data-shp-guard');
    var view = pdp && b.hasAttribute('data-shg-label');
    /* נעול: 3 השניות שאחרי הוספה, או בזמן שמחכים לתשובת הסל על הפריט הזה */
    var locked = now < (busy[vid] || 0) || !!waiting[vid];
    var fresh = known && now - syncedAt < MAX_AGE;
    /* המצב ידוע והפריט לא בסל: הלחיצה ממשיכה כמו שהיא למטפל של התבנית, בלי בקשת רשת בדרך */
    if (!locked && !view && fresh && !inCart[vid]) { passed(b, vid); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    /* לחיצה נוספת בזמן הנעילה לא שולחת, ובדף המוצר גם לא פותחת את הסל שוב. ההודעה מוצגת רק כשהפריט באמת בסל */
    if (locked) { if (!pdp && inCart[vid]) showToast(); return; }
    if (view) { openCart(); return; }
    /* המצב ידוע והפריט בסל */
    if (fresh) { markCards(); markPdp(); if (pdp) openCart(); else showToast(); return; }
    /* המצב לא ידוע או ישן: משוב מיידי על הכפתור (המחלקה שהתבנית עצמה שמה בזמן הוספה), ושואלים את הסל */
    waiting[vid] = true;
    b.classList.add('is-loading');
    syncCart().then(function (c) {
      waiting[vid] = false;
      if (c && known && inCart[vid]) { b.classList.remove('is-loading'); if (pdp) openCart(); else showToast(); return; }
      b.setAttribute('data-shg-pass', '1');
      b.click();
    });
  }, true);

  /* שינוי בסל מתוך הדף (הוספה, הסרה, כמות, משלימים): התבנית משדרת cart-update עם הסל המעודכן, בלי בקשת רשת נוספת */
  document.addEventListener('cart-update', function (e) {
    var c = e && e.detail;
    if (!c || !Array.isArray(c.items) || typeof c.item_count !== 'number') return;
    applyCart(c, Date.now());
  });
  /* חזרה לדף מהיסטוריית הדפדפן (bfcache), וחזרה ללשונית אחרי שהסל אולי השתנה בלשונית אחרת */
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && known) syncCart(); });

  /* קטגוריה וחיפוש: סימון "בסל" גם בכרטיסים שנטענים בגלילה אינסופית */
  var grid = document.querySelector('.productListing');
  if (grid) new MutationObserver(function () { markCards(); }).observe(grid, { childList: true, subtree: true });
  /* סנכרון ראשון בטעינה, בקטגוריה ובדף המוצר */
  if (grid || document.querySelector('[data-shp-guard]')) syncCart();
})();
